import { Component, Output, EventEmitter, Input, OnInit } from '@angular/core';
import { IAttachment } from '@common/models/IAttachment';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
})
export class FileUploadComponent implements OnInit {
  @Input() attachmentData: IAttachment
  @Output() fileUploadData = new EventEmitter<any>()
  formName: string
  attachmentTypes: string = ""

  constructor() {
    this.formName = uuidv4();
  }

  ngOnInit(): void {
    this.attachmentTypes = this.getFormattedAllowableFileTypes(this.attachmentData?.typeDefinition);
  }

  getFormattedAllowableFileTypes(typeDefinition: any): string {
    if (!typeDefinition?.allowableFileTypes) {
      return '';
    }

    const allowable = typeDefinition.allowableFileTypes;
    let fileTypes: string[] = [];

    if (typeof allowable === 'string') {
      fileTypes = allowable
        .split(',')
        .map(ext => ext.trim().toLowerCase())
        .filter(ext => ext.length > 0);
    } else if (Array.isArray(allowable)) {
      fileTypes = allowable
        .map(ext => ext.trim().toLowerCase())
        .filter(ext => ext.length > 0);
    }

    return fileTypes.length ? fileTypes.map(ext => '.' + ext).join(',') : '';
  }

  onBasicUpload(event: any) {
    const files = event.target.files;
    this.fileUploadData.emit(files);
  }
}